module.exports = __webpack_public_path__ + "img/shiba-head-level6.2cae64ce.png";